import { Tag } from 'antd';
import React from 'react';
import useSegmentField from 'core/hooks/useSegmentField';

const colors = {
  waitingForAuthorization: 'orange',
  pending: 'grey',
  accepted: 'green',
  rejected: 'red',
  refuse: 'red'
};

const TreatmentPartnerStatus = ({ status }) => {
  const segmentFields = useSegmentField();
  
  const labels = {
    waitingForAuthorization: `Aguardando autorização do ${segmentFields.serviceRecipient}`,
    pending: `Aguardando ${segmentFields.serviceProvider}`,
    accepted: 'Aceito',
    rejected: 'Convite rejeitado',
    refuse: `Não autorizado pelo ${segmentFields.serviceRecipient}`
  };
  
  return <Tag color={colors[status]}>{labels[status]}</Tag>;
};

export default TreatmentPartnerStatus;

